import React, { Component } from "react";
import { connect } from "react-redux";

import { Apply_Promo } from "../../store/actions";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ItemsCarousel from "react-items-carousel";
import PromoItem from "./PromoItem";
import { isStorefrontFoundationEnabled } from "../Storefront/featureFlags";
export class index extends Component {
  rootRef = React.createRef();
  state = {
    activeItemIndex: 0,
    activeHeight: null,
  };

  componentDidMount() {
    this.startAutoScroll();
    this.observeCards();
    window.addEventListener("resize", this.measureActiveCard);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.promotions !== this.props.promotions || prevProps.coupons !== this.props.coupons ||
        prevProps.settings !== this.props.settings || prevProps.applied_promos !== this.props.applied_promos ||
        prevProps.language !== this.props.language) this.observeCards();
    if (prevState.activeItemIndex !== this.state.activeItemIndex) this.measureActiveCard();
  }

  measureActiveCard = () => {
    if (!isStorefrontFoundationEnabled(this.props.settings)) return;
    const cards = this.rootRef.current?.querySelectorAll(".sf-promo-card");
    if (!cards?.length) return;
    if (this.state.activeItemIndex >= cards.length) {
      this.setState({ activeItemIndex: 0 });
      return;
    }
    const height = Math.ceil(cards[this.state.activeItemIndex].getBoundingClientRect().height);
    if (height > 0 && height !== this.state.activeHeight) this.setState({ activeHeight: height });
  };

  observeCards = () => {
    if (this.sizeObserver) this.sizeObserver.disconnect();
    if (!isStorefrontFoundationEnabled(this.props.settings)) return;
    if (typeof ResizeObserver !== "undefined") {
      this.sizeObserver = new ResizeObserver(this.measureActiveCard);
      if (this.rootRef.current) this.rootRef.current.querySelectorAll(".sf-promo-card").forEach(card => this.sizeObserver.observe(card));
    }
    this.measureActiveCard();
  };

  componentWillUnmount() {
    this.stopAutoScroll();
    if (this.sizeObserver) this.sizeObserver.disconnect();
    window.removeEventListener("resize", this.measureActiveCard);
    clearTimeout(this.idleTimeout);
  }

  startAutoScroll = () => {
    if (!this.props.settings.auto_scroll_promos) return;
    if (!this.intervalAutoScroll) {
      this.intervalAutoScroll = setInterval(this.scrollPromo, 5000);
    }
  };
  stopAutoScroll = (fromTouch = false) => {
    if (!this.props.settings.auto_scroll_promos) return;
    if (this.intervalAutoScroll) {
      clearInterval(this.intervalAutoScroll);
      this.intervalAutoScroll = null;
    }
    if (fromTouch) {
      if (this.idleTimeout) {
        clearTimeout(this.idleTimeout);
      }
      this.idleTimeout = setTimeout(this.startAutoScroll, 10000);
    }
  };

  scrollPromo = () => {
    const { coupons, promotions } = this.props; // or state
    const length =
      coupons.length +
      promotions.filter(
        (promo) =>
          !promo.hide_promotion &&
          (promo.remaining ||
            this.props.applied_promos.find((p) => p.id === promo.id))
      ).length;

    this.setState((prev) => ({
      activeItemIndex: (prev.activeItemIndex + 1) % length,
    }));
  };
  render() {
    let Coupons_List = [];
    Coupons_List = this.props.coupons.map((promo) => (
      <PromoItem promo={promo} is_coupon={true} key={"coupon " + promo.code} />
    ));
    let Promo_List = [];
    if (this.props.promotions && this.props.promotions.length) {
      this.props.promotions.forEach((promo) => {
        if (
          !promo.hide_promotion &&
          (promo.remaining ||
            this.props.applied_promos.find((p) => p.id === promo.id))
        ) {
          Promo_List.push(
            <PromoItem
              promo={promo}
              is_coupon={false}
              key={"promotion " + promo.id + " " + promo.name}
            />
          );
        }
      });
    }
    const chevronWidth = 20;
    const v2 = isStorefrontFoundationEnabled(this.props.settings);
    return (
      <div
        ref={this.rootRef}
        onLoad={v2 ? this.measureActiveCard : undefined}
        className={`${
          Coupons_List.length + Promo_List.length > 1 ? "px-4" : "px-0"
        }`}
        style={{
          padding: `0px  0px`,
          paddingTop: "20px",
          paddingBottom: "20px",
          ...(v2 && this.state.activeHeight ? { "--sf-promo-height": `${this.state.activeHeight}px` } : {}),
        }}
        onMouseEnter={this.stopAutoScroll}
        onTouchStart={() => this.stopAutoScroll(true)}
        onMouseLeave={this.startAutoScroll}
      >
        <ItemsCarousel
          classes={v2 ? { itemsWrapper: "sf-promo-carousel__viewport", itemsInnerWrapper: "sf-promo-carousel__track" } : undefined}
          numberOfCards={1}
          gutter={20}
          disableSwipe={
            Promo_List.length + Coupons_List.length <= 1 ? true : false
          }
          requestToChangeActive={(e) => this.setState({ activeItemIndex: e })}
          activeItemIndex={this.state.activeItemIndex}
          leftChevron={
            <ArrowBackIosIcon className="ml-2" width={chevronWidth} />
          }
          rightChevron={
            <ArrowForwardIosIcon className="" width={chevronWidth} />
          }
          outsideChevron
          chevronWidth={chevronWidth}
        >
          {Promo_List.concat(Coupons_List)}
        </ItemsCarousel>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    labels: state.store.labels,
    coupons: state.store.store.promos,
    promotions: state.store.store.smart_promos,
    applied_promos: state.cart.smart_promos,
    settings: state.store.store.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    Apply_Promo: (promo) => dispatch(Apply_Promo(promo)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(index);
